module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Langing-page-w540.60a4f7cf.webp";